import { defineMessages } from 'react-intl';
var CANCEL_POLICY_HREF = 'https://help.classpass.com/hc/articles/207942743-What-is-the-class-cancellation-policy-';
export var messages = defineMessages({
  cancelCta: {
    id: 'cancel-reservation-modal.cancel-cta',
    defaultMessage: 'Cancel this class'
  },
  cancellationFailureHeading: {
    id: 'cancel-reservation-modal.cancellation-failure.heading',
    defaultMessage: 'Cancellation failed'
  },
  cancellationSuccessHeading: {
    id: 'cancel-reservation-modal.cancellation-success.heading',
    defaultMessage: 'Reservation cancelled'
  },
  cancellationFailure: {
    id: 'cancel-reservation-modal.cancellation-failure',
    defaultMessage: 'Your reservation could not be cancelled at this time.<br />Please try again later.'
  },
  cancellationSuccess: {
    id: 'cancel-reservation-modal.cancellation-success',
    defaultMessage: 'Your reservation has been cancelled successfully.'
  },
  cancellationPolicy: {
    id: 'cancel-reservation-modal.cancellation-policy',
    defaultMessage: 'I understand that this class starts within 12 hours and canceling will incur a late cancellation <a href={href} target="help">fee</a>.',
    values: {
      href: CANCEL_POLICY_HREF
    }
  },
  cancellationPolicyFlywheel: {
    id: 'cancel-reservation-modal.cancellation-policy.flywheel',
    defaultMessage: 'I understand that Flywheel/FlyBarre reservations must be canceled by 5pm the night before class, so canceling now will result in a <a href={href} target="help">fee</a>.',
    values: {
      href: CANCEL_POLICY_HREF
    }
  },
  credits: {
    id: 'cancel-reservation-modal.credits',
    defaultMessage: '<strong>{creditsCount}</strong> {creditsCount, plural, one {credit} other {credits}}'
  },
  creditsRefund: {
    id: 'cancel-reservation-modal.credits-refund',
    defaultMessage: 'We’ll refund your <strong>{creditsCount} {creditsCount, plural, one {credit} other {credits}}</strong>'
  },
  doneCta: {
    id: 'cancel-reservation-modal.done',
    defaultMessage: 'Done'
  },
  poweredByMindbody: {
    id: 'cancel-reservation-modal.powered-by-mindbody',
    defaultMessage: 'Powered by MindBody'
  }
});